import { render, staticRenderFns } from "./channel_product.vue?vue&type=template&id=fcfc65ee&scoped=true"
import script from "./channel_product.vue?vue&type=script&lang=js"
export * from "./channel_product.vue?vue&type=script&lang=js"
import style0 from "./channel_product.vue?vue&type=style&index=0&id=fcfc65ee&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcfc65ee",
  null
  
)

export default component.exports